export const KEYS = {
    USER: 'user',
    TOKEN: 'accessToken',
    PERMISSIONS: 'permissions',
    // Add more keys as needed
}